import React, { useEffect, useState, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PendoService } from "@services";
import FilterComponent from "./FilterComponent";
import ProductComponent from "./ProductComponent";
import { ConfigurationContext } from "../../../contexts/Configuration";
import SearchIcon from "@mui/icons-material/Search";
import { ClearIcon } from "@mui/x-date-pickers";
import { IconButton } from "@mui/material";
import { UseLabels } from "../CommonComponent/UseLabels";
import { SearchContext } from "../../../contexts/Search";

const SearchCoverage = ({
  clientProductConfigurations,
  setShowResults,
  onChangeBenefitType,
  onChangeNPI,
  onChangeSearchTerm,
  onChangeIndication,
  handleCoverageSearch,
  handleFilterChange,
  handleProductChange,
  selectedState,
  setSelectedState,
  benefitTypes,
  setResultMessage,
  selectedBenefitType,
  selectedProduct,
  products,
  zipCode,
  setShowBenefitType,
}) => {
  const { appliedConfiguration } = useContext(ConfigurationContext);
  const { productId, productName, indicationName, setIndicationName } = useContext(SearchContext);
  const [selectedZipCode, setZipCode] = useState(zipCode);
  const [states, setStates] = useState([]);
  const [indications, setIndications] = useState([]);
  const [selectedTerritory, setSelectedTerritory] = useState("");
  const [searchNPI, setSearchNPI] = useState("");
  const [selectedIndication, setSelectedIndication] = useState(null);
  const [message, setMessage] = useState("");
  const [npiMessage, setNpiMessage] = useState("");
  const [filterMessage, setFilterMessage] = useState("");
  const [productMessage, setProductMessage] = useState("");
  const [allowStateSearch, setAllowStateSearch] = useState(false);
  const [stateSearchOnly, setStateSearchOnly] = useState(false);
  const [allowNPISearch, setAllowNPISearch] = useState(false);
  const [allowIndicationSelection, setAllowIndicationSelection] = useState(false);
  const [allowProductSelection, setAllowProductSelection] = useState(false);
  const [geoSearchOpen, setGeoSearchOpen] = useState(false);
  const [indicationMessage, setIndicationMessage] = useState("");
  const [allowFilterSelection, setAllowFilterSelection] = useState(false);
  const [Filters, setFilters] = useState(null);
  const [FilterValue, setFilterValues] = useState([]);
  const [initialPageLoad, setInitialPageLoad] = useState(true);
  const [isFilterSame, setIsFilterSame] = useState(true);
  const [showSearchButtonIcon, setShowSearchButtonIcon] = useState(false);
  const [searchCriteriaValidity, setSearchCriteriaValidity] = useState([]);
  const [performCoverageSearch, setPerformCoverageSearch] = useState(false);
  const [isAutoSearchEnabled, setIsAutoSearchEnabled] = useState(false);
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");
  const usZipCodeRegex = new RegExp(/^\d{5}(-\d{4})?(?!-)$/);
  const autocompleteRef = useRef();
  const npiTextFieldRef = useRef();
  const zipTextFieldRef = useRef();
  const indicationTextFieldRef = useRef();
  const searchButtonRef = useRef();
  const { getLabel } = UseLabels();
  const filterComponenetProps = {
    Filters: Filters,
    OnFilterChange: OnFilterChange,
    allowIndicationSelection: allowIndicationSelection,
    isFilterSame: isFilterSame,
  };

  const productComponenetProps = {
    products: products,
    OnProductChange: OnProductChange,
  };

  const compareFilterCriteria = (criteria1, criteria2) => {
    if (criteria1.length !== criteria2.length) return false;
    for (let i = 0; i < criteria1.length; i++) {
      if (
        criteria1[i].filterCriteria !== criteria2[i].filterCriteria ||
        // criteria1[i].coverageFinderColumnTitles !== criteria2[i].coverageFinderColumnTitles ||
        criteria1[i].displayOrder !== criteria2[i].displayOrder
      ) {
        return false;
      }
    }
    return true;
  };

  const getFilters = () => {
    let benefitTypeid = selectedBenefitType == "Medical" ? 1 : 2;
    var filterMedical = appliedConfiguration.coverageFinderFilters?.find((filter) => filter.benefitTypeId === 1);
    var filterPharmacy = appliedConfiguration.coverageFinderFilters?.find((filter) => filter.benefitTypeId === 2);
    const isFilterTypeSame = filterMedical?.filterType === filterPharmacy?.filterType;
    const areCriteriaSame =
      filterMedical && filterPharmacy
        ? compareFilterCriteria(filterMedical?.filterCriteria, filterPharmacy?.filterCriteria)
        : false;
    setIsFilterSame(isFilterTypeSame && areCriteriaSame);
    const filters = appliedConfiguration.coverageFinderFilters?.find((x) => x.benefitTypeId == benefitTypeid && x.enabled);
    setFilters(filters);
    setAllowFilterSelection(!!filters);
    if (!(isFilterTypeSame && areCriteriaSame)) {
      setFilterValues([]);
    }
  };
  const autocompleteStyles = {
    width: allowIndicationSelection && allowProductSelection ? "200px" : "300px",
  };

  useEffect(() => {
    let ignore = false;
    let isStateSearchOnly = false;
    let usesFilter = false;
    let allowIndication = false;
    let allowProduct = false;
    let allowNPI = false;
    async function getConfig() {
      if (!ignore) {
        const settings = appliedConfiguration?.settings;
        const cfConfig = appliedConfiguration?.coverageFinderConfiguration;
        let allowState = cfConfig?.geographyType?.toLowerCase() != "zip code only";
        isStateSearchOnly = cfConfig?.geographyType?.toLowerCase() == "state only";
        setStateSearchOnly(isStateSearchOnly);
        if (zipCode) {
          setSelectedTerritory(zipCode);
        }

        if (settings) {
          allowNPI = settings.findIndex((setting) => setting.settingId === 76 && setting.isEnabled === true) > -1;
          allowProduct = settings.findIndex((setting) => setting.settingId === 83 && setting.isEnabled === true) > -1;
          setShowSearchButtonIcon(
            settings.findIndex((setting) => setting.settingId === 89 && setting.isEnabled === true) > -1
          );
        }

        setIndicationComponent(settings);
        setAllowProductSelection(allowProduct && products.length > 1);
        setAllowStateSearch(allowState);
        setAllowNPISearch(allowNPI);
        if (!allowNPI) {
          setSearchNPI("");
        }
        onChangeBenefitType(benefitTypes[0]);
        if (allowState) {
          // Sort the states array by name
          let states = appliedConfiguration.states.sort((a, b) =>
            a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0
          );
          setStates(states);
        }
        let benefitTypeid = selectedBenefitType == "Medical" ? 1 : 2;
        usesFilter = appliedConfiguration.coverageFinderFilters?.some(
          (x) => x.benefitTypeId == benefitTypeid && x.enabled
        );
        setAllowFilterSelection(usesFilter);
      }
    }

    function setIndicationComponent(settings) {
      setAllowIndicationSelection(false);
      if (settings) {
        allowIndication =
          settings.findIndex((setting) => setting.settingId === 77 && setting.isEnabled === true) > -1;
      }
      const indArray = clientProductConfigurations.indications;
      const allowedIndicationProjectIds = clientProductConfigurations.configurations
        .filter(
          (config) => Array.isArray(config.settings) &&
            config.settings.some((setting) => setting.settingId === 77 && setting.isEnabled === true) &&
            Number.isInteger(config.indicationId)
        )
        .map((config) => config.projectId);
      if (allowIndication && indArray != null && indArray.length > 0) {
        const allowIndicationArrays = allowedIndicationProjectIds.length > 0
          ? indArray.filter((indication) => allowedIndicationProjectIds.includes(indication.projectId))
          : indArray;
        let indicationList = Array.from(
          new Map(
            allowIndicationArrays.map(item => [item.id, { id: item.id, name: item.name }])
          ).values()
        );
        if (!selectedIndication) {
          setIndications(indicationList);
        }
        setAllowIndicationSelection(allowIndication);
      }
    };

    function allowAutoZipCodeSearch() {
      return !isStateSearchOnly && !allowIndication && !allowProduct && !usesFilter;
    };

    if (clientProductConfigurations) {
      getConfig();

      if (zipCode && initialPageLoad && allowAutoZipCodeSearch()) {
        searchCoverage();
        setInitialPageLoad(false);
        setIsAutoSearchEnabled(true);
      }
      else if (isAutoSearchEnabled) {
        if (isSearchCriteriaValid()) {
          searchCoverage();
        }
        else {
          setShowResults(false);
        }
      }
    };
    return () => {
      ignore = true;
    };
  }, [clientProductConfigurations, appliedConfiguration]);

  useEffect(() => {
    getFilters();
  }, [appliedConfiguration, selectedBenefitType, matchesMobileWidth]);

  useEffect(() => {
    if (performCoverageSearch) {
      searchCoverage();
    }
  }, [performCoverageSearch]);

  function OnFilterChange(newValue, isFilterSame) {
    const newArrayValue = Array.isArray(newValue) ? newValue : [newValue];
    setFilterValues(newArrayValue);
    handleFilterChange(newArrayValue, isFilterSame);
  }

  function OnProductChange(newValue) {
    handleProductChange(newValue);
  }

  const handleSelectedIndication = (event, value) => {
    setSelectedIndication(value);
    setIndicationName(value.name);
    onChangeIndication(value.id);
    if (value.id === 0) {
      setShowResults(false);
    }
  };

  const handleZipSearch = (event) => {
    setSelectedTerritory(event.target.value);
    onChangeSearchTerm(event.target.value);

    if (event.target.value === "") {
      setShowResults(false);
    }
  };

  const handleSelectedTerritory = (event, value) => {
    setSelectedTerritory(value);
    setZipCode(null);
    onChangeSearchTerm(value);
    if (isNaN(value)) {
      //Set this to handle updating the map with a selected state
      setSelectedState(value);
    } else {
      setSelectedState(null);
    }
    if (value === "") {
      setShowResults(false);
    }

    if (event && event.keyCode == 13 && value) {
      setPerformCoverageSearch(true);
      setIsAutoSearchEnabled(true);
      event.target.blur();
    }
  };



  const handleNPISearch = (event) => {
    setSearchNPI(event.target.value);
    onChangeNPI(event.target.value);
    if (event.target.value === "") {
      setShowResults(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.keyCode == 13 && event.target.value) {
      setPerformCoverageSearch(true);
      setIsAutoSearchEnabled(true);
      event.target.blur();
      if (!isNaN(Number(event.target.value[0]))) {
        event.stopPropagation();
      }
    }
  };

  const handleSearchClick = () => {
    setIsAutoSearchEnabled(true);
    searchCoverage();
  };

  const searchCoverage = () => {
    resetSearchState();
    const searchCriteriaValidityStatus = getSearchCriteriaValidityStatus();
    setSearchCriteriaValidity(searchCriteriaValidityStatus);

    if (searchCriteriaValidityStatus?.every((criteria) => criteria.isValid)) {
      blurInputElements();
      trackSearchButtonClick((selectedState || selectedTerritory) ? "Territory" : (searchNPI ? "NPI" : ""));
      handleCoverageSearch();
    } else {
      resetFocusToSearchButton();
      setShowBenefitType(false);
      setShowResults(false);
      setValidationErrorMessage(searchCriteriaValidityStatus);
    }
  };

  const resetSearchState = () => {
    setMessage("");
    setFilterMessage("");
    setProductMessage("");
    setNpiMessage("");
    setIndicationMessage("");
    setResultMessage("");
    setGeoSearchOpen(false);
    setPerformCoverageSearch(false);
  };

  const blurInputElements = () => {
    if (autocompleteRef?.current) {
      autocompleteRef.current.blur();
    }
    if (npiTextFieldRef?.current) {
      npiTextFieldRef.current.blur();
    }
    if (zipTextFieldRef?.current) {
      zipTextFieldRef.current.blur();
    }
    if (indicationTextFieldRef?.current) {
      indicationTextFieldRef.current.blur();
    }
  };

  const resetFocusToSearchButton = () => {
    blurInputElements();
    if (searchButtonRef?.current) {
      searchButtonRef.current.focus();
    }
  };

  const isSearchCriteriaValid = () => {
    const benefitTypeid = selectedBenefitType == "Medical" ? 1 : 2;
    const allowIndication = appliedConfiguration?.settings?.find((setting) => setting.settingId === 77 && setting.isEnabled === true);
    const allowProduct = appliedConfiguration?.settings?.find((setting) => setting.settingId === 83 && setting.isEnabled === true);
    const allowFilterSelection = appliedConfiguration?.coverageFinderFilters?.some((filter) => filter.benefitTypeId == benefitTypeid && filter.enabled);

    const isIndicationValid = !allowIndication || !!selectedIndication;
    const isProductValid = !allowProduct || !!selectedProduct;
    const isGeographyDetailsValid = isValidGeoSearch() || !!(searchNPI && searchNPI.length === 10 && !isNaN(searchNPI));
    const isTerritoryAndNPIBothProvided = (selectedState || selectedTerritory) && searchNPI;
    return isIndicationValid && isProductValid && isGeographyDetailsValid && !allowFilterSelection && !isTerritoryAndNPIBothProvided;
  };

  const getSearchCriteriaValidityStatus = () => {
    const isIndicationValid = !allowIndicationSelection || !!selectedIndication;
    const isProductValid = !allowProductSelection || !!selectedProduct;
    const isGeographyDetailsValid = isValidGeoSearch() || !!(searchNPI && searchNPI.length === 10 && !isNaN(searchNPI));
    const isFilterValid = !allowFilterSelection || FilterValue.length > 0;
    const isTerritoryAndNPIBothProvided = (selectedState || selectedTerritory) && searchNPI;
    return [
      { searchCriteriaName: "Indication", isValid: isIndicationValid },
      { searchCriteriaName: "Product", isValid: isProductValid },
      { searchCriteriaName: "GeographyDetails", isValid: isGeographyDetailsValid },
      { searchCriteriaName: "Filter", isValid: isFilterValid },
      { searchCriteriaName: "TerritoryAndNPICheck", isValid: !isTerritoryAndNPIBothProvided },
    ];
  };

  const isValidGeoSearch = () => {
    let foundState = false;
    if (
      (selectedTerritory && states.find((st) => st.name.toLowerCase() === selectedTerritory.toLowerCase())) ||
      (selectedState && states.find((st) => st.name.toLowerCase() === selectedState.toLowerCase()))
    ) {
      foundState = true;
    } else {
      foundState = false;
    }
    return (
      ((stateSearchOnly || allowStateSearch) && foundState) || //Check if valid search by State
      (!stateSearchOnly && usZipCodeRegex.test(selectedTerritory)) || //Check if valid search by ZIP code
      (selectedZipCode !== null && selectedZipCode !== undefined && usZipCodeRegex.test(selectedZipCode)) //if a zip code was passed in to the component default to that for searches
    );
  };

  const trackSearchButtonClick = (searchType) => {
    const normalizedSearchType = typeof searchType === "string" ? searchType?.toLowerCase() : "";
    switch (normalizedSearchType) {
      case "territory":
        PendoService.getInstance().trackEvent("Search Button Click", "searchCoverage > Search Territory", selectedTerritory, productId, productName, indicationName);
        break;
      case "npi":
        PendoService.getInstance().trackEvent("Search Button Click", "searchCoverage > Search NPI", searchNPI, productId, productName, indicationName);
        break;
      default:
        return;
    }
    if (FilterValue && FilterValue.length > 0) {
      const filterCriteria = FilterValue.filter((item) => item && item.filterCriteria).map(
        (item) => item.filterCriteria
      );

      if (filterCriteria.length > 0) {
        PendoService.getInstance().trackEvent("Search Button Click", "searchCoverage > Search Filters", filterCriteria, productId, productName, indicationName);
      }
    }
  };

  const setValidationErrorMessage = (searchCriteriaValidityStatus) => {
    const geoSearchType = stateSearchOnly ? "State" : (allowStateSearch ? "ZIP Code or State" : "ZIP Code");
    const isIndicationInvalid = searchCriteriaValidityStatus?.some((criteria) => criteria.searchCriteriaName === "Indication" && !criteria.isValid);
    const isProductInvalid = searchCriteriaValidityStatus?.some((criteria) => criteria.searchCriteriaName === "Product" && !criteria.isValid);
    const isFilterInvalid = searchCriteriaValidityStatus?.some((criteria) => criteria.searchCriteriaName === "Filter" && !criteria.isValid);
    const isGeographyDetailsInvalid = searchCriteriaValidityStatus?.some((criteria) => criteria.searchCriteriaName === "GeographyDetails" && !criteria.isValid);
    const isTerritoryAndNPIBothProvided = searchCriteriaValidityStatus?.some((criteria) => criteria.searchCriteriaName === "TerritoryAndNPICheck" && !criteria.isValid);

    if (isIndicationInvalid)
      setIndicationMessage("Please select an Indication.");

    if (isProductInvalid)
      setProductMessage("Please select a Product.");

    if (isFilterInvalid)
      setFilterMessage("Please select a criteria.");

    if (isTerritoryAndNPIBothProvided) {
      setMessage("You may only choose one field to search by.");
      return;
    }

    if (searchNPI && isGeographyDetailsInvalid) {
      setNpiMessage("Please enter a valid NPI.");
      return;
    }

    if ((selectedState || selectedTerritory) && isGeographyDetailsInvalid) {
      setMessage("Please enter a valid " + geoSearchType + ".");
      return;
    }

    if (!selectedState && !selectedTerritory) {
      const searchType = (allowNPISearch && !searchNPI) ? geoSearchType + " or NPI" : geoSearchType;
      setMessage("Please enter a valid " + searchType + ".");
    }
  };

  const getTextFieldInputProps = (params, errorMessageElementId, criteriaName) => {
    const invalid = searchCriteriaValidity?.some((criteria) => criteria.searchCriteriaName === criteriaName && !criteria.isValid);
    return matchesMobileWidth ? {
      inputProps: {
        ...params.inputProps,
        onBlur: undefined,
        "aria-errormessage": errorMessageElementId,
        "aria-invalid": invalid
      }
    } : {
      inputProps: {
        ...params.inputProps,
        "aria-errormessage": errorMessageElementId,
        "aria-invalid": invalid
      }
    };
  };

  return (
    <>
      <div className="norstella-cf-flexAlignResponsive" part="cfDivSearch">
        {allowIndicationSelection && (
          <>
            <div className="norstella-cf-indicationDiv" part="cfIndicationDiv">
              <label className="norstella-cf-lblIndication norstella-cf-searchLabel" htmlFor="indicationSelect"> {getLabel("cfIndicationLabel", "Indication")}</label>
              <div className="norstella-cf-flexAlignCenterRow norstella-cf-bottomMargin norstella-cf-rightMargin norstella-cf-searchComponents norstella-cf-indicationDDLDiv">
                <Autocomplete
                  className="norstella-cf-searchText"
                  style={!matchesMobileWidth ? autocompleteStyles : {}}
                  disablePortal
                  blurOnSelect
                  handleHomeEndKeys
                  disableClearable
                  id="indicationSelect"
                  options={indications}
                  value={selectedIndication}
                  onChange={handleSelectedIndication}
                  renderInput={(params) =>
                    <TextField {...params}
                      placeholder="Select Indication"
                      {...getTextFieldInputProps(params, "divIndicationMessage", "Indication")}
                    />}
                  sx={{
                    input: {
                      "&::placeholder": {
                        color: "#595959",
                        opacity: 1
                      }
                    }
                  }}
                  getOptionLabel={(option) => option.name}
                  part="cfIndicationSelect"
                  ref={indicationTextFieldRef}
                />
                <div className="norstella-cf-message" part="cfMessage"
                  id="divIndicationMessage"
                  aria-live="polite" aria-atomic="true">
                  {indicationMessage}
                </div>
              </div>
            </div>
          </>
        )}

        {allowProductSelection && (
          <>
            <div className="norstella-cf-productDiv" part="cfProductDiv">
              <label className="norstella-cf-lblProduct norstella-cf-searchLabel" htmlFor="productSelect">{getLabel("cfProductLabel", "Product")}</label>
              <div className="norstella-cf-flexAlignCenterRow norstella-cf-bottomMargin norstella-cf-rightMargin norstella-cf-searchComponents norstella-cf-productDDLDiv">
                <ProductComponent {...productComponenetProps}></ProductComponent>
                <div className="norstella-cf-message" part="cfMessage"
                  id="divProductMessage"
                  aria-live="polite" aria-atomic="true">
                  {productMessage}
                </div>
              </div>
            </div>
          </>
        )}

        <div
          className={`norstella-cf-flexAlignCenterRow norstella-cf-bottomMargin ${matchesMobileWidth ? "" : "norstella-cf-searchComponents"}`}
        >
          <div className="norstella-cf-div-col" id="norstella-cf-geoSearch">
            <label part="cfLocationLabel" className="norstella-cf-lblLocation norstella-cf-searchLabel" htmlFor="geoSearch">{getLabel("cflocationLabel", "Location")}</label>
            {!allowStateSearch && (
              <TextField
                id="geoSearch"
                placeholder="Enter ZIP Code"
                part="cfGeoSearch"
                className="norstella-cf-searchText"
                variant="outlined"
                onChange={handleZipSearch}
                onKeyDown={handleKeyDown}
                value={selectedTerritory}
                ref={zipTextFieldRef}
                {...getTextFieldInputProps({}, "divMessage", "Geography")}
              />
            )}
            {allowStateSearch && (
              <Autocomplete
                style={!matchesMobileWidth ? autocompleteStyles : {}}
                disablePortal
                className="norstella-cf-searchText"
                freeSolo
                {...(matchesMobileWidth && { blurOnSelect: true })}
                handleHomeEndKeys
                id="geoSearch"
                open={geoSearchOpen}
                onOpen={() => {
                  setGeoSearchOpen(true);
                }}
                onClose={() => {
                  setGeoSearchOpen(false);
                }}
                value={selectedState ?? selectedTerritory}
                options={states}
                onKeyDown={handleKeyDown}
                onInputChange={handleSelectedTerritory}
                placeholder={stateSearchOnly ? "Select State" : "Enter ZIP Code or State"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <IconButton tabIndex={selectedTerritory?.length > 0 ? 0 : -1} className="norstella-cf-autocomplete-custom-close" aria-label="Clear button" onClick={() => {
                          setSelectedTerritory("");
                          setGeoSearchOpen(false);
                          setSelectedState(null);
                        }}>
                          <ClearIcon />
                        </IconButton>
                      )
                    }}
                    placeholder={stateSearchOnly ? "Select State" : "Enter ZIP Code or State"}
                    {...getTextFieldInputProps(params, "divMessage", "GeographyDetails")}
                  />
                )}
                getOptionLabel={(option) => option.name ?? option}
                sx={{
                  input: {
                    "&::placeholder": {
                      color: "#595959",
                      opacity: 1
                    }
                  }
                }}
                part="cfGeoSearch"
                ref={autocompleteRef}
              />
            )}
            <div aria-live="polite" aria-atomic="true">
              {!matchesMobileWidth && (
                <div className="norstella-cf-message norstella-cf-message-error" part="cfMessage"
                  id="divMessage">
                  {message}
                </div>
              )}
            </div>
          </div>
          {allowNPISearch && (
            <>
              <span className="norstella-cf-searchSeparator">or</span>
              <div className="norstella-cf-div-col">
                <label className="norstella-cf-lblNPI norstella-cf-searchLabel" htmlFor="npiSearch">{getLabel("cfNPILabel", "NPI")}</label>
                <TextField
                  id="npiSearch"
                  placeholder="Enter NPI"
                  className="norstella-cf-npiSearch"
                  part="cfNpiSearch"
                  variant="outlined"
                  onChange={handleNPISearch}
                  onKeyDown={handleKeyDown}
                  ref={npiTextFieldRef}
                  {...getTextFieldInputProps({}, "divNPIMessage", "GeographyDetails")}
                />
                <div aria-live="polite" aria-atomic="true">
                  {!matchesMobileWidth && npiMessage !== "" && (
                    <div className="norstella-cf-message" part="cfMessage"
                      id="divNPIMessage">
                      {npiMessage}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <div aria-live="polite" aria-atomic="true">
          {matchesMobileWidth && (message !== "" || npiMessage !== "") && (
            <div className="norstella-cf-flexAlignCenterRow norstella-cf-bottomMargin">
              <>
                {message !== "" && (
                  <div className="norstella-cf-message" part="cfMessage"
                    id="divMessage">
                    {message}
                  </div>
                )}
                {allowNPISearch && npiMessage !== "" && (
                  <div className="norstella-cf-message norstella-npi-message" part="cfNpimessage"
                    id="divNPIMessage">
                    {npiMessage}
                  </div>
                )}
              </>
            </div>
          )}
        </div>
        {Filters && (
          <>
            <div className="norstella-cf-filterdiv" part="cfFilterDiv">
              <label className="norstella-cf-lblFilterCriteria norstella-cf-searchLabel" htmlFor="selectFilter">{getLabel("cfCriteriaLabel", "Criteria")}</label>
              <div
                className={
                  matchesMobileWidth
                    ? "norstella-cf-div-col"
                    : "norstella-cf-flexAlignCenterRow norstella-cf-bottomMargin norstella-cf-rightMargin"
                }
              >
                <FilterComponent {...filterComponenetProps}></FilterComponent>
                <div
                  className="norstella-cf-message"
                  part="cfMessage"
                  id="divFilterCriteriaMessage"
                  aria-live="polite" aria-atomic="true"
                >
                  {filterMessage}
                </div>
              </div>
            </div>
          </>
        )}

        {!matchesMobileWidth && (
          <Button
            variant="contained"
            className="norstella-cf-searchButton"
            id="searchButton"
            onClick={handleSearchClick}
            part="cfSearchButton"
            ref={searchButtonRef}
            startIcon={showSearchButtonIcon ? <SearchIcon /> : null}
            disableFocusRipple={true}
          >
            Search
          </Button>
        )}
      </div>
      {matchesMobileWidth && (
        <Button
          variant="contained"
          className="norstella-cf-searchButton"
          id="searchButton"
          onClick={handleSearchClick}
          part="cfSearchButton"
          ref={searchButtonRef}
          startIcon={showSearchButtonIcon ? <SearchIcon /> : null}
          disableFocusRipple={true}
        >
          Search
        </Button>
      )}
    </>
  );
};

export default SearchCoverage;

